// Stored with the identity answer as-is, so these are values, not locale copy.
export const ANOTHER_SOCIETY = 'Another society';

export const SOCIETIES = [
  'ABRAMUS (Brazil)',
  'APRA AMCOS (Australia)',
  'ASCAP (US)',
  'BMI (US)',
  'BUMA/STEMRA (Netherlands)',
  'GEMA (Germany)',
  'PRS for Music (UK)',
  'SACEM (France)',
  'SACM (Mexico)',
  'SBACEM (Brazil)',
  'SESAC (US)',
  'SGAE (Spain)',
  'SIAE (Italy)',
  'SOCAN (Canada)',
  'STIM (Sweden)',
  'UBC (Brazil)',
  ANOTHER_SOCIETY,
  'None / not sure',
];
